import React from 'react';
import classnames from 'classnames';
import IconTip from '@/components/icon-tip';

import './index.less';

function HoverTool(props) {
  const text = props.text || props.children;
  const { type = '', style } = props;

  if (!text) return null;

  if (!props.hover) return text;

  return (
    <span style={style} className={classnames('tips-wrap', props.className, type)}>
      <span className="tips-text">{text}</span>
      <IconTip
        arrowPointAtCenter
        overlayClassName={props.overlayClassName}
        style={{ color: 'inherit' }}
        title={props.hover}
        placement={props.placement || 'topRight'}
        size="small"
      />
    </span>
  );
}

export default React.memo(HoverTool);
